import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import React from "react";
import {
  FormDropDownList,
  FormInput,
} from "../../SharedComponents/form-components";
import {
  carrierEmail1,
  carrierEmail2,
  carrierPhNo1,
  carrierPhNo2,
  cmEmail1,
  cmEmail2,
  cmPhNo1,
  cmPhNo2,
  ctsiScac,
} from "../../SharedComponents/validators";

import "./CarrierMasterParentForm.scss"

function CarrierMasterParentForm({ item, onSubmit, cancelEdit }) {
  return (
    <Dialog title={"Edit"} onClose={cancelEdit}>
      <Form
        initialValues={item}
        onSubmit={onSubmit}
        render={(formRenderProps) => (
          <>
            <FormElement style={{ width: "25vw", height: "80vh" }}>
              {/* OPS Segment */}
              <fieldset>
                <Field
                  name={"parentScac"}
                  component={FormDropDownList}
                  label={"Parent SCAC "}
                  disabled
                />
              </fieldset>

              {/* CTSI SCAC */}
              <fieldset>
                <Field
                  name={"ctsiScac"}
                  component={FormInput}
                  label={"CTSI SCAC "}
                  validator={ctsiScac}
                  className="astric-red"
                  disabled={item['ctsiScac'] ? true : false}
                />
              </fieldset>

              {/* CM email ID1 */}
              <fieldset>
                <Field
                  name={"cmEmail1"}
                  component={FormInput}
                  label={"CM email ID1 "}
                  validator={cmEmail1}
                />
              </fieldset>

              {/* Phone No 1  */}
              <fieldset>
                <Field
                  name={"cmPhNo1"}
                  component={FormInput}
                  label={"Phone No 1 "}
                  validator={cmPhNo1}
                />
              </fieldset>

              {/* CM email ID2 */}
              <fieldset>
                <Field
                  name={"cmEmail2"}
                  component={FormInput}
                  label={"CM email ID2 "}
                  validator={cmEmail2}
                />
              </fieldset>

              {/* Phone No 2 */}
              <fieldset>
                <Field
                  name={"cmPhNo2"}
                  component={FormInput}
                  label={"Phone No 2 "}
                  validator={cmPhNo2}
                />
              </fieldset>

              {/* Carrier Email 1 */}
              <fieldset>
                <Field
                  name={"carrierEmail1"}
                  component={FormInput}
                  label={"Carrier Email 1 "}
                  validator={carrierEmail1}
                />
              </fieldset>

              {/* Carrier Phone 1 */}
              <fieldset>
                <Field
                  name={"carrierPhNo1"}
                  component={FormInput}
                  label={"Carrier Phone 1 "}
                  validator={carrierPhNo1}
                />
              </fieldset>

              {/* Carrier Email 2 */}
              <fieldset>
                <Field
                  name={"carrierEmail2"}
                  component={FormInput}
                  label={"Carrier Email 2 "}
                  validator={carrierEmail2}
                />
              </fieldset>

              {/* Carrier Phone 2 */}
              <fieldset>
                <Field
                  name={"carrierPhNo2"}
                  component={FormInput}
                  label={"Carrier Phone 2 "}
                  validator={carrierPhNo2}
                />
              </fieldset>

              <div className="k-form-buttons" style={{ paddingBottom: "15px" }}>
                {/* Update */}
                <button
                  type={"submit"}
                  className="btn k-button k-button-icontext"
                  disabled={!formRenderProps.valid}
                >
                  Update
                </button>

                {/* Cancel */}
                <button
                  type={"submit"}
                  className="btn k-button k-button-icontext rejectbtn"
                  onClick={cancelEdit}
                >
                  Cancel
                </button>
                {/* <div>
                  <pre>{JSON.stringify(item, null, 2)}</pre>
                  <pre>{JSON.stringify(!formRenderProps.valid || formRegionValue.region === null, null, 2)}</pre>
                </div> */}
              </div>
            </FormElement>
          </>
        )}
      />
    </Dialog>
  );
}

export default CarrierMasterParentForm;
